var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingIco3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.918,
    height: 37.919,
    viewBox: "0 0 37.918 37.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -1.649,
    x2: 0.5,
    y2: 0.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2979ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fcbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -15.868,
    x2: 0.5,
    y2: 3.884,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2274.158,2756.153l.644,6.249,2.479-.256a16.478,16.478,0,0,0,3.147,5.837l-1.568,1.929,4.874,3.963,1.568-1.928a16.446,16.446,0,0,0,6.356,1.89l.256,2.479,6.248-.645-.255-2.479a16.444,16.444,0,0,0,5.838-3.147l1.928,1.568,3.963-4.874-1.929-1.568a16.463,16.463,0,0,0,1.891-6.356l2.479-.256-.644-6.248-2.478.255a16.475,16.475,0,0,0-3.147-5.838l1.568-1.927-4.874-3.963-1.568,1.927a16.472,16.472,0,0,0-6.357-1.891l-.255-2.478-6.248.644.255,2.479a16.454,16.454,0,0,0-5.838,3.147l-1.928-1.568-3.963,4.873,1.928,1.568a16.459,16.459,0,0,0-1.891,6.357Zm17.869-9.377a10.637,10.637,0,1,1-9.491,11.671A10.636,10.636,0,0,1,2292.027,2746.776Z",
    transform: "translate(-2274.158 -2738.397)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2323.627,2790.088a2.489,2.489,0,1,0-2.731-2.221A2.489,2.489,0,0,0,2323.627,2790.088Z",
    transform: "translate(-2304.413 -2768.652)",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIco3);
export default __webpack_public_path__ + "static/media/settingIco3.92d81916a5c501c031de1b035da24a74.svg";
export { ForwardRef as ReactComponent };